<template>
  <div>
    <b-input v-model="searchStr" hide-details placeholder="Пошук аудиту">
      <template #prepend-inner>
        <v-icon icon="mdi-magnify" size="small"></v-icon>
      </template>
    </b-input>

    <div class="d-flex flex-column ga-2 overflow-y-auto mt-3">
      <b-global-loader :loading="$loading.isLoading('getAuditList')">
        <v-card v-for="audit in auditList" :key="audit.id" border>
          <v-card-text class="pa-1">
            <v-checkbox
              v-model="selectedAuditList"
              :value="audit.id"
              color="blue-darken-3"
              hide-details>
              <template #label>
                <div>
                  <div class="font-size-16">{{ audit.name }}</div>
                  <div
                    v-if="!audit.startAuditDate && !audit.endAuditDate"
                    class="text-disabled">
                    Дата не вказана
                  </div>
                  <div v-else class="text-disabled">
                    {{ new CustomDate(audit.startAuditDate).toString() }} -
                    {{ new CustomDate(audit.endAuditDate).toString() }}
                  </div>
                </div>
              </template>
            </v-checkbox>
          </v-card-text>
        </v-card>

        <div v-if="!auditList.length" class="text-disabled text-center py-5">
          Відсутні аудити можливі для додавання в даний план
        </div>
      </b-global-loader>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType, ref, watch } from 'vue'
import { Dialog } from '@/dialog'
import { debounce } from 'lodash'
import { CustomDate } from 'best-modules/utils'
import { handleAsync } from 'best-modules/plugins'
import { BGlobalLoader } from 'best-modules/components'
import { attachAuditsToPlan, auditsAddable } from '@/requests/plan'

export default {
  name: 'AuditAttach',
  components: { BGlobalLoader },
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { CustomDate },
  setup(props) {
    const searchStr = ref<any>(null)
    const auditList = ref<any[]>([])

    const selectedAuditList = ref<any[]>([])

    const getAuditList = (search: any = null) => {
      return handleAsync('getAuditList', () => {
        return auditsAddable({
          search,
          year: props.dialog.dialogData.plan.year,
        }).then(res => {
          auditList.value = res
        })
      })
    }

    watch(searchStr, debounce(getAuditList, 500))

    getAuditList()

    const submit = () => {
      if (selectedAuditList.value.length) {
        return attachAuditsToPlan(props.dialog.dialogData.plan.id, {
          auditIds: selectedAuditList.value,
        })
      } else {
        return Promise.resolve(false)
      }
    }

    return { searchStr, auditList, selectedAuditList, submit }
  },
}
</script>

<style lang="scss" scoped>
:deep(.v-checkbox .v-selection-control) {
  min-height: 25px !important;
}
</style>
